// extracted by mini-css-extract-plugin
module.exports = {"hostList":"host-list_hostList__Gfdis","avatar":"host-list_avatar__OruJW","avatarHidden":"host-list_avatarHidden___Wt_l","placehoder":"host-list_placehoder__jDXKV"};